import script from "./HomeConsole.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeConsole.vue?vue&type=script&setup=true&lang=ts"

import "./HomeConsole.vue?vue&type=style&index=0&id=17c359d1&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c359d1"]])

export default __exports__